import TranslationsConfigType from '../../translations/translationType';
import { checkForOnlyNumbersInName } from '../transaction/CrossBorderPayment/form/validate';

export interface ValidationMessage {
    receiverNameInput?: string;
    addressInput?: string;
    countryInput?: string;
    postCodeInput?: string;
    townInput?: string;
}
export interface Props {
    receiverName: string;
    translated: TranslationsConfigType;
    country?: string;
    requiredAddress?: boolean;
    address?: string;
    requiredPostCode?: boolean;
    postCode?: string;
    requiredTown?: boolean;
    town?: string;
}

const validateForm = ({
    receiverName,
    country,
    translated,
    requiredAddress = true,
    address,
    requiredPostCode = true,
    postCode,
    requiredTown = true,
    town,
}: Props): ValidationMessage => {
    const validate: ValidationMessage = {};
    if (receiverName === '') {
        validate.receiverNameInput = translated.crossBorderPayment.newReceiver.receiverNameError;
    }
    if (checkForOnlyNumbersInName(receiverName ?? '')) {
        validate.receiverNameInput = translated.crossBorderPayment.needOneCharacter;
    }
    if (!country) {
        validate.countryInput = translated.crossBorderPayment.newReceiver.selectedCountryError;
    }
    if (requiredAddress) {
        if (address === '') {
            validate.addressInput = translated.crossBorderPayment.newReceiver.missingCreditorDetails;
        }
        if (requiredPostCode && postCode === '') {
            validate.postCodeInput = translated.crossBorderPayment.newReceiver.missingPostCode;
        }
        if (requiredTown && town === '') {
            validate.townInput = translated.crossBorderPayment.newReceiver.missingTown;
        }
    }

    return validate;
};

export default validateForm;
